import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

export interface IGlobalTexts {
  optional: string;
  emailIsIncorrect: string;
  serviceWorkerUpdateText: string;
  requestErrorText: string;
  nextStoryText: string;
  paginationNext: string;
  paginationPrevious: string;
  all: string;
  allExperts: string;
  share: string;
  popular: string;
  myBlogPosts: string;
  myPresentations: string;
  myLatestBlogPosts: string;
  authorAtSoftwareHut: string;
  loadMore: string;
  jobOffertApplication: string;
  jobOffertRequirementsTitle: string;
  weOfferTitle: string;
  sendingMail: string;
  reCAPTCHAErrorMessage: string;
  mailSendSuccessMessage: string;
  jobTypeTitle: string;
  jobOfferDesctiptionTitle: string;
  joinOurAwesomeTeam: string;
  whereAndWhen: string;
  upcomingEvents: string;
  pastEvents: string;
  noEvents: string;
  close: string;
}

export class GlobalTextsModel extends ContentItem {
  get optional(): string {
    return get(this._config, 'elements.optional.value', '');
  }
  get emailIsIncorrect(): string {
    return get(this._config, 'elements.email_is_incorrect.value', '');
  }
  get serviceWorkerUpdateText(): string {
    return get(this._config, 'elements.service_worker_update_text.value', '');
  }

  get requestErrorText(): string {
    return get(this._config, 'elements.request_error.value', '');
  }

  get nextStoryText(): string {
    return get(this._config, 'elements.next_story.value', '');
  }

  get paginationNext(): string {
    return get(this._config, 'elements.pagination_next.value', '');
  }

  get paginationPrevious(): string {
    return get(this._config, 'elements.pagination_previous.value', '');
  }

  get all(): string {
    return get(this._config, 'elements.all.value', '');
  }

  get allExperts(): string {
    return get(this._config, 'elements.all_experts.value', '');
  }

  get share(): string {
    return get(this._config, 'elements.share.value', '');
  }

  get popular(): string {
    return get(this._config, 'elements.popular.value', '');
  }

  get myBlogPosts(): string {
    return get(this._config, 'elements.my_blog_posts.value', '');
  }

  get myPresentations(): string {
    return get(this._config, 'elements.my_presentations.value', '');
  }

  get myLatestBlogPosts(): string {
    return get(this._config, 'elements.my_latest_blog_post.value', '');
  }

  get authorAtSoftwareHut(): string {
    return get(this._config, 'elements.author_at_softwarehut.value', '');
  }

  get loadMore(): string {
    return get(this._config, 'elements.load_more.value', '');
  }

  get jobOffertApplication(): string {
    return get(this._config, 'elements.job_offert_application.value', '');
  }

  get jobOffertRequirementsTitle(): string {
    return get(this._config, 'elements.job_offert_requirements.value', '');
  }

  get weOfferTitle(): string {
    return get(this._config, 'elements.we_offer_title.value', '');
  }

  get sendingMail(): string {
    return get(this._config, 'elements.sending_mail.value', '');
  }

  get reCAPTCHAErrorMessage(): string {
    return get(this._config, 'elements.recaptcha_error_message.value', '');
  }

  get mailSendSuccessMessage(): string {
    return get(this._config, 'elements.mail_send_success_message.value', '');
  }

  get jobTypeTitle(): string {
    return get(this._config, 'elements.job_type_title.value', '');
  }

  get jobOfferDesctiptionTitle(): string {
    return get(this._config, 'elements.job_offer_description.value', '');
  }

  get joinOurAwesomeTeam(): string {
    return get(this._config, 'elements.join_our_awesome_team.value', '');
  }

  get noEvents(): string {
    return get(this._config, 'elements.no_events.value', '');
  }

  get whereAndWhen(): string {
    return get(this._config, 'elements.where_and_when.value', '');
  }

  get upcomingEvents(): string {
    return get(this._config, 'elements.upcoming_events.value', '');
  }

  get pastEvents(): string {
    return get(this._config, 'elements.past_events.value', '');
  }

  get close(): string {
    return get(this._config, 'elements.close.value', '');
  }

  public static create(data): IGlobalTexts {
    const {
      optional,
      emailIsIncorrect,
      serviceWorkerUpdateText,
      requestErrorText,
      nextStoryText,
      paginationNext,
      paginationPrevious,
      allExperts,
      all,
      share,
      popular,
      myBlogPosts,
      myPresentations,
      myLatestBlogPosts,
      authorAtSoftwareHut,
      loadMore,
      jobOffertApplication,
      jobOffertRequirementsTitle,
      weOfferTitle,
      sendingMail,
      reCAPTCHAErrorMessage,
      mailSendSuccessMessage,
      jobTypeTitle,
      jobOfferDesctiptionTitle,
      joinOurAwesomeTeam,
      whereAndWhen,
      upcomingEvents,
      pastEvents,
      noEvents,
      close
    } = new GlobalTextsModel(data);
    return {
      optional,
      emailIsIncorrect,
      serviceWorkerUpdateText,
      requestErrorText,
      nextStoryText,
      paginationNext,
      paginationPrevious,
      allExperts,
      all,
      share,
      popular,
      myBlogPosts,
      myPresentations,
      myLatestBlogPosts,
      authorAtSoftwareHut,
      loadMore,
      jobOffertApplication,
      jobOffertRequirementsTitle,
      weOfferTitle,
      sendingMail,
      reCAPTCHAErrorMessage,
      mailSendSuccessMessage,
      jobTypeTitle,
      jobOfferDesctiptionTitle,
      joinOurAwesomeTeam,
      whereAndWhen,
      upcomingEvents,
      pastEvents,
      noEvents,
      close
    };
  }
}
